<div class="row">
  <div class="col-12">
    <nb-card class="mb-4">
      <nb-card-header>
        <div class="d-flex justify-content-between align-items-center">
          <h2>NFC Reader Monitoring</h2>
          <button class="btn btn-primary" (click)="triggerMonitoring()">
            <i class="fas fa-sync-alt me-2"></i>Test NFC Monitoring
          </button>
        </div>
      </nb-card-header>
      <nb-card-body>
        <!-- Summary Stats -->
        <div class="row mb-4 text-center">
          <div class="col-md-3">
            <nb-card status="success">
              <nb-card-body>
                <h6>Online Readers</h6>
                <h3>{{ getOnlineStoresCount() }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-3">
            <nb-card status="danger">
              <nb-card-body>
                <h6>Offline Readers</h6>
                <h3>{{ getOfflineStoresCount() }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-3">
            <nb-card status="primary">
              <nb-card-body>
                <h6>Total Readers</h6>
                <h3>{{ getTotalStoresCount() }}</h3>
              </nb-card-body>
            </nb-card>
          </div>
          <div class="col-md-3">
            <nb-card status="info">
              <nb-card-body>
                <h6>Uptime</h6>
                <h3>{{ getOnlinePercentage() }}%</h3>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <!-- Last Updated -->
        <div class="row mb-2">
          <div class="col-12 text-end">
            <small class="text-muted">Last updated: {{ getLastUpdated() }}</small>
          </div>
        </div>

        <!-- Date Range Selector -->
        <div class="row mb-4">
          <div class="col-12">
            <nb-card>
              <nb-card-body>
                <div class="row mb-2">
                  <div class="col">
                    <h6>Date Range Filter</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <input nbInput placeholder="Date Range" [nbDatepicker]="rangepicker" [(ngModel)]="date">
                    <nb-rangepicker #rangepicker (rangeChange)="updateRangeDate($event)"></nb-rangepicker>
                  </div>
                  <div class="col-md-2">
                    <button nbButton status="primary" (click)="clearDate()">Clear</button>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select nbSelect fullWidth [(ngModel)]="selectedInterval" (change)="onIntervalChange($event)">
                        <option value="15min">15 Minutes</option>
                        <option value="hour">Hourly</option>
                        <option value="day">Daily</option>
                        <option value="month">Monthly</option>
                      </select>
                    </div>
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <!-- Historical Data Summary -->
        <div class="row mb-4" *ngIf="timeSeriesData && timeSeriesData.length > 0">
          <div class="col-12">
            <nb-card>
              <nb-card-header>
                <h5>Historical Data Summary</h5>
              </nb-card-header>
              <nb-card-body>
                <div class="row text-center">
                  <div class="col-md-4">
                    <h6>Historical Uptime</h6>
                    <h4>{{ getHistoricalUptime() }}%</h4>
                  </div>
                  <div class="col-md-4">
                    <h6>Total Readings</h6>
                    <h4>{{ historical.totalReadings || 0 }}</h4>
                  </div>
                  <div class="col-md-4">
                    <h6>Online Readings</h6>
                    <h4>{{ historical.onlineReadings || 0 }}</h4>
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <!-- Graph -->
        <div class="row">
          <div class="col-12">
            <div class="chart-container" style="position: relative; height:400px; width:100%">
              <canvas baseChart
                [type]="lineChartType"
                [data]="lineChartData"
                [options]="lineChartOptions">
              </canvas>
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="white" type="ball-circus" [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner> 